import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/building/importer/buildingImporterActions';

export default importerReducers(actions);
